export function affinityOpportunityUrl(affinityOppId: string | number): string {
  return `https://ember.affinity.co/opportunities/${encodeURIComponent(String(affinityOppId))}`;
}
